import { SharedProps, VariantType, useSnackbar } from "notistack";

export interface SnackbarProps extends SharedProps {
  message: string;
  variant: VariantType;
}

const useDialogAlert = () => {
  const { enqueueSnackbar } = useSnackbar();

  const snackbar = (props: SnackbarProps) => {
    const { message, variant, ...rest } = props;
    enqueueSnackbar(message, {
      variant,
      ...rest,
      style: { fontSize: "1.4rem" },
    });
  };

  const snackbarWarn = (message: string) => {
    enqueueSnackbar(message, {
      variant: "warning",
      style: { fontSize: "1.4rem" },
    });
  };

  const snackbarError = (message: string) => {
    enqueueSnackbar(message, {
      variant: "error",
      style: { fontSize: "1.4rem" },
    });
  };

  const snackbarSuccess = (message: string) => {
    enqueueSnackbar(message, {
      variant: "success",
      style: { fontSize: "1.4rem" },
    });
  };

  return { snackbar, snackbarError, snackbarSuccess, snackbarWarn };
};

export default useDialogAlert;
